import type { ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Button } from '../components/ui/button.js'
import { Icon } from '../components/installer/icons.js'
import { addDays, formatClosedStamp, formatMonDayYear } from '../lib/dates.js'
import { useDemoStore } from '../state/store.js'
import { useStep } from '../state/useStep.js'

export const SummaryScreen = (): ReactElement => {
  const { dispatch } = useDemoStore()
  const { goto } = useStep()

  const footer = (
    <Button
      size="xl"
      onClick={() => {
        dispatch({ type: 'SEAL' })
        goto('job-closed')
      }}
    >
      <Icon.CheckCircle /> Close Job
    </Button>
  )

  return (
    <AppShell
      title="Job summary"
      showBack
      onBack={() => goto('proof-bundle')}
      progress={1}
      footer={footer}
    >
      <div className="installer-surface page fade-in">

        {/* Seal banner */}
        <div className="summary-lock">
          <div className="lock-icon">
            <Icon.Lock />
          </div>
          <div>
            <span className="summary-chip">{formatClosedStamp(new Date())}</span>
            <div className="summary-title-sm">Seals the proof bundle</div>
            <div className="summary-sub">
              Closing this job seals the delivery record, checkpoint proofs, and exception notes
              for the final handoff.
            </div>
          </div>
        </div>

        {/* System closeout overview */}
        <div className="section-label">SYSTEM CLOSEOUT OVERVIEW</div>
        <div className="closeout-cards">
          <div className="closeout-card success">
            <div className="icon">
              <Icon.CheckCircle />
            </div>
            <div>
              <div className="closeout-label">ANTI-TIP ANCHOR</div>
              <div className="closeout-body">Restraint anchored to stud, tug test passed</div>
            </div>
          </div>
          <div className="closeout-card success">
            <div className="icon">
              <Icon.Camera />
            </div>
            <div>
              <div className="closeout-label">PROOF BUNDLE</div>
              <div className="closeout-body">5 required proof checkpoints</div>
            </div>
          </div>
        </div>

        {/* Service history saved */}
        <div className="section-label">SERVICE HISTORY SAVED</div>
        <div className="conf-card">
          <div className="history-date">{formatMonDayYear(addDays(new Date(), -158))}</div>
          <div className="history-title">Prior delivery at this address</div>
          <div className="history-body">
            Delivery history shows a prior white-glove handoff at this address completed with a sealed
            proof bundle and no damage or service-tier disputes on record.
          </div>
        </div>
        <div className="conf-card">
          <div className="history-date">{formatMonDayYear(addDays(new Date(), -288))}</div>
          <div className="history-title">Room condition baseline saved</div>
          <div className="history-body">
            The bedroom walls and flooring were documented on arrival, which helps separate
            pre-existing conditions from new wall- or floor-damage claims.
          </div>
        </div>

      </div>
    </AppShell>
  )
}
